import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ImgContainer } from '@/components';
import "./style.less";

interface CardProps {
    className: string,
    title: string,
    profile: string,
    cover: string,
    time: string,
    href: string,
}

function Card({ className = "", title, profile, cover, time, href = "" }: CardProps) {

    const hasHttp = href.includes("http");

    return (
        <div className={`com-card bg-white ${className}`}>
            {href
                ? hasHttp
                    ? <a href={href} target="_blank">
                        <ImgContainer src={cover} width={170} scale={12 / 16} />
                    </a>
                    : <Link to={href}>
                        <ImgContainer src={cover} width={170} scale={12 / 16} />
                    </Link>
                : <ImgContainer src={cover} width={190} scale={12 / 16} />}
            <div className={`com-card__content${!href ? "--full" : ""} p-sm child-top-xs`}>
                {href
                    ? hasHttp
                        ? <a href={href} target="_blank"><p className="font-size-16 bold dark-title nowrap-ellipsis link">{title}</p></a>
                        : <Link to={href}><p className="font-size-16 bold dark-title nowrap-ellipsis link">{title}</p></Link>
                    : <p className="font-size-16 bold dark-title nowrap-ellipsis">{title}</p>}
                <p className="font-size-14 dark-second nowrap--ellipsis-3">{profile}</p>
                <p className="font-size-12 dark-disable">{time}</p>
            </div>
        </div>
    )
}

export default Card;